import { render, staticRenderFns } from "./BufferingPage.vue?vue&type=template&id=2e98b042&scoped=true"
import script from "./BufferingPage.vue?vue&type=script&lang=js"
export * from "./BufferingPage.vue?vue&type=script&lang=js"
import style0 from "./BufferingPage.vue?vue&type=style&index=0&id=2e98b042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e98b042",
  null
  
)

export default component.exports